import React from 'react';
import { WifiOff } from 'lucide-react';

/**
 * OfflineBanner - Displayed at the top of the app when in offline mode.
 */
export const OfflineBanner: React.FC = () => (
  <div className="bg-amber-500/90 border-b-2 border-amber-600 px-4 py-2">
    <div className="flex items-center justify-center gap-2 text-amber-950 text-sm font-semibold">
      <WifiOff size={16} aria-hidden />
      <span>Đang chạy ở chế độ ngoại tuyến</span>
    </div>
  </div>
);

export default OfflineBanner;
